import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    access: string;
    createdBy: string;
    dateCreated: string;
    dateUploaded: string;
    fileType: string;
    folderAccess: string;
    items: string;
    project: string;
    size: string;
    status: string;
    storage: string;
    uploadedBy: string;
    users: string;
    workspace: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for project access */
            access: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ItemDetailMetaQS.access?c=1r1xq48ymr69d", defaultMessage: "Project Access" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for created by */
            createdBy: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ItemDetailMetaQS.createdBy?c=2u0a1ynxs0mhz", defaultMessage: "Created By" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for date created */
            dateCreated: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ItemDetailMetaQS.dateCreated?c=2kb8fcug33grf", defaultMessage: "Date Created" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for date uploaded */
            dateUploaded: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ItemDetailMetaQS.dateUploaded?c=11a6bbbmn8s51", defaultMessage: "Date Uploaded" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for file type */
            fileType: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ItemDetailMetaQS.fileType?c=1cuvmtz0lm3xx", defaultMessage: "File Type" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for folder access */
            folderAccess: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ItemDetailMetaQS.folderAccess?c=1h2bm4zfjje6y", defaultMessage: "Folder Access" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for number of items */
            items: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ItemDetailMetaQS.items?c=1os9neh6qjhpd", defaultMessage: "Number of Items" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for project */
            project: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ItemDetailMetaQS.project?c=1y2semxo3c9fl", defaultMessage: "Project" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for size */
            size: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ItemDetailMetaQS.size?c=38m0cmesgfwnh", defaultMessage: "Size" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for status */
            status: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ItemDetailMetaQS.status?c=2rksycb4ttyye", defaultMessage: "Status" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for storage */
            storage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ItemDetailMetaQS.storage?c=1sao7shjzhwoe", defaultMessage: "Storage" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for uploaded by */
            uploadedBy: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ItemDetailMetaQS.uploadedBy?c=3rdtvmv780qm8", defaultMessage: "Uploaded By" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for users */
            users: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ItemDetailMetaQS.users?c=bg2ys1zz0ska", defaultMessage: "Users" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for workspace */
            workspace: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ItemDetailMetaQS.workspace?c=fvis4ig6qtg3", defaultMessage: "Workspace" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
